import React, { useState, useEffect, useRef, memo } from 'react'
import { Motion, spring } from 'react-motion'
import { makeStyles } from '@material-ui/core/styles'
import { styles } from './styles'
import { QuoteIcon } from '../../../../Assets/Images/logos'
import { CompanyTrustSections } from '../CompanyTrustSections/CompanyTrustSections'
import { testimonialMessages, TestimonialLogos } from './const/testimonials'

const dotSpacing = 24
const initialOffset = -dotSpacing

export const CustomersTestimonials = memo(() => {
  const useStyles = makeStyles(styles)
  const classes = useStyles()

  const [currentIndex, setCurrentIndex] = useState(0)
  const dragStartRef = useRef(null)

  const testimonialRef = useRef(null)
  const timerRef = useRef(null)

  useEffect(() => {
    startTimer()

    return () => clearInterval(timerRef.current)
  }, [])

  const startTimer = () => {
    clearInterval(timerRef.current)

    timerRef.current = setInterval(() => {
      handleNext()
    }, 10000)
  }

  const handleNext = () => {
    setCurrentIndex(prevIndex => (prevIndex + 1) % testimonialMessages.length)
  }

  const handlePrevious = () => {
    setCurrentIndex(prevIndex =>
      prevIndex === 0 ? testimonialMessages.length - 1 : prevIndex - 1,
    )
  }

  const handleDragStart = e => {
    dragStartRef.current = e.clientX
  }

  const handleDragEnd = e => {
    if (dragStartRef.current !== null) {
      const dragEnd = e.clientX
      const difference = dragStartRef.current - dragEnd

      handleDrag(difference)
    }
  }

  const handleTouchStart = e => {
    dragStartRef.current = e.touches[0].clientX
  }

  const handleTouchEnd = e => {
    if (dragStartRef.current !== null) {
      const endX = e.changedTouches[0].clientX
      const difference = dragStartRef.current - endX

      handleDrag(difference)
    }
  }

  const handleDrag = difference => {
    if (Math.abs(difference) > 50) {
      if (difference > 0) {
        handlePrevious()
      } else {
        handleNext()
      }

      startTimer()
    }

    dragStartRef.current = null
  }

  const currentTestimonial = testimonialMessages[currentIndex]
  const CurrentLogo = TestimonialLogos[currentTestimonial.company]

  return (
    <div className={classes.container}>
      <div
        className={classes.testimonialContent}
        ref={testimonialRef}
        draggable="true"
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
        style={{ cursor: 'grab' }}
      >
        <div className={classes.testimonialText} key={currentIndex}>
          <QuoteIcon width="24" height="24" className={classes.icon} />
          <p className={classes.message}>{currentTestimonial.message}</p>

          <div className={classes.logoContainer}>
            <CurrentLogo className={classes.logo} />

            <div className={classes.authorContainer}>
              <p className={classes.author}>{currentTestimonial.author}</p>
              <p className={classes.role}>{currentTestimonial.role}</p>
            </div>
          </div>
        </div>
      </div>

      <div className={classes.sliderContainer}>
        <div className={classes.dotsWrapper}>
          {Array.from({ length: testimonialMessages.length }).map(
            (_, index) => (
              <div
                key={index}
                className={classes.dot}
                onClick={() => {
                  setCurrentIndex(index)
                  startTimer()
                }}
              />
            ),
          )}
        </div>

        <Motion
          style={{
            x: spring(initialOffset + currentIndex * dotSpacing, {
              stiffness: 300,
              damping: 25,
            }),
          }}
        >
          {({ x }) => (
            <div
              className={classes.slider}
              style={{ transform: `translateX(${x}px)` }}
            />
          )}
        </Motion>
      </div>

      <CompanyTrustSections />
    </div>
  )
})
